import { ROUTE_PARAMS } from '../route-params';

/**
 * Customers controller route constants (EXAMPLE)
 *
 * Demonstrates kebab-case params and complex nested routes
 * Maps to @Controller('customers')
 *
 * This is an example showing how to structure route constants
 * for controllers with multiple parameters and nested resources.
 */
export const CUSTOMERS_ROUTES = {
  // Base routes
  ROOT: '',
  GET_BY_ID: ROUTE_PARAMS.ID,

  // Example with customer-id param (kebab-case)
  GET_BY_CUSTOMER_ID: ROUTE_PARAMS.CUSTOMER_ID,

  // Complex nested route examples:
  // /customers/:id/users/:user-id
  CUSTOMER_USERS: `${ROUTE_PARAMS.ID}/users/${ROUTE_PARAMS.USER_ID}`,

  // /customers/:id/metadata
  CUSTOMER_METADATA: `${ROUTE_PARAMS.ID}/metadata`,

  // /customers/:customer-id/roles
  CUSTOMER_ROLES: `${ROUTE_PARAMS.CUSTOMER_ID}/roles`,
} as const;

/**
 * Type representing all possible customer routes
 */
export type CustomersRoute =
  (typeof CUSTOMERS_ROUTES)[keyof typeof CUSTOMERS_ROUTES];
